export var VERTEX_SHADER = 'vs';
export var FRAGMENT_SHADER = 'fs';
//# sourceMappingURL=constants.js.map